<style></style>

<template>
<div class="component-container">
    <a :href="$basePath+'/connections'" class="btn btn-orange-blue btn-sm btn-connect">Connect To Programs</a>

    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" id="demo">
            <a class="nav-link active" id="connected-programs-tab" data-toggle="tab" href="#connected-programs" role="tab" aria-controls="connected-programs" aria-selected="true">Connected Programs</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" id="invited-programs-tab" data-toggle="tab" href="#invited-programs" role="tab" aria-controls="invited-programs" aria-selected="false">Invited Programs</a>
        </li>
    </ul>

    <div class="tab-content table-container" id="myTabContent">
        <div class="tab-pane fade show active" id="connected-programs" role="tabpanel" aria-labelledby="connected-programs-tab">
            <programs-table 
            ></programs-table>
        </div>
        <div class="tab-pane fade" id="invited-programs" role="tabpanel" aria-labelledby="invited-programs-tab">
            <connection-requests-table
                :connection-requests="connectionRequests"
            ></connection-requests-table>
            <invites-table
            ></invites-table>
        </div>
    </div>
</div>
</template>

<script>
    import ProgramsTable  from './ProgramsTable'
    import InvitesTable from './InvitesTable'
    import ConnectionRequestsTable from './ConnectionRequestsTable'

    export default {
        components: {
            ProgramsTable,
            InvitesTable,
            ConnectionRequestsTable
        },
        props: {
            connectons: {
                required: false
            },
            connectionRequests: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                filter: null,
                sortConnectedOptions: [
                    { 
                        text: "User Information", 
                        value: 'user-info' 
                    },
                    {
                        text: 'Connected',
                        value: 'connected'
                    },
                    {
                        text: 'Most Recent Self-Assessment',
                        value: 'mostRecentAssessmentDate'
                    },
                    {
                        value: 'mostRecentActionPlanDate',
                        text: 'Most Recent Action Planning',
                    }
                ],
                sortInvitedOptions: [
                    {
                        value: 'user-info',
                        text: 'User Information',
                    },
                    {
                        value: 'date-first-invited',
                        text: 'Date First Invited',
                    },
                    {
                        value: 'date-last-invite',
                        text: 'Date of Last Invite',
                    },
                ]

            }
        }
    }
</script>